import { FunctionComponent } from 'react';
import Button from '../../../shared/components/Button/Button';
import Plus from '../../../shared/components/Icons/Plus';
import CircularProgress from '../../../shared/components/Progress/CircularProgress';

interface Props {
	addDraft: () => void;
	isAddingDraft?: boolean;
}

const InventoryAllocationReportInProgress: FunctionComponent<Props> = ({
	addDraft,
	isAddingDraft,
}) => (
	<div>
		<p className="text-ca-gray mt-10">Numbers are being crunched...</p>
		<p className="text-ca-gray">
			This may take a while, but there is no need to wait.
		</p>
		<p className="text-ca-gray mb-10">
			You can configure another draft report in the meantime.
		</p>
		<Button className="flex gap-3" onClick={addDraft} disabled={isAddingDraft}>
			{isAddingDraft ? (
				<CircularProgress size="text" />
			) : (
				<Plus className="h-3" />
			)}
			{isAddingDraft ? 'Adding draft' : 'Add draft'}
		</Button>
	</div>
);

export default InventoryAllocationReportInProgress;
